import { render, staticRenderFns } from "./editDistributionType.vue?vue&type=template&id=64fbde74&scoped=true&"
import script from "./editDistributionType.vue?vue&type=script&lang=js&"
export * from "./editDistributionType.vue?vue&type=script&lang=js&"
import style0 from "./editDistributionType.vue?vue&type=style&index=0&id=64fbde74&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fbde74",
  null
  
)

export default component.exports